class ProductListController {
  /* @ngInject */
  constructor(ProductFilterService, RouterService, ProductService, InfiniteTriggerService, $timeout) {
    this.routerService = RouterService;
    this.productService = ProductService;
    this.infiniteTriggerService = InfiniteTriggerService;
    this.productFilterService = ProductFilterService;
    this.timeout = $timeout;
    this.onChangeFilters = this.onChangeFilters.bind(this);
    this.onSuccessFilters = this.onSuccessFilters.bind(this);
  }

  $onInit() {
    const {products, scrollPosition, currentPage, totalProducts, perPage} = this.productService.store;
    this.totalProducts = totalProducts;
    this.currentPage = currentPage || 1;
    this.perPage = perPage;

    if (products) {
      this.products = products;
      this.timeout(() => {
        document.documentElement.scrollTop = scrollPosition;
      });
    } else {
      this.searchProducts(this.routerService.state.params);
    }
  }

  onChangeFilters(paramsFilters) {
    this.searchProducts(paramsFilters);
  }

  onSuccessFilters(activeFilters) {
    this.filters = Object.keys(activeFilters).reduce((arr, key) => {
      let _label;
      if (key === 'q' && activeFilters[key].value) {
        _label = `Query String: ${activeFilters[key].value}`;
      } else {
        _label = activeFilters[key].value ? activeFilters[key].label : null;
      }
      _label && arr.push(_label);
      return arr;
    }, []).join(' / ');
    this.breadcrumbs = this.createBreadCrumbFromActiveFilters(activeFilters);
  }

  getProducts(params) {
    const paramsEnriched = this.productFilterService.defaultParams(params);
    const paramsEnrichedWithAvailability = this.productFilterService.enrichParamsWithAvailability(paramsEnriched);
    return this.productService.query(paramsEnrichedWithAvailability, {cacheable: false});
  }

  onProductSearchSuccess(newData) {
    this.products = newData.products;
    this.onProductSuccess(newData);
  }

  onProductUpdateSuccess(newData) {
    const _products = [...this.products, ...newData.products];
    this.products = _products;
    this.onProductSuccess(newData);
  }

  onProductSuccess({total, page, perPage}) {
    this.httpUpdateProductsIsPending = false;
    this.httpSearchProductsIsPending = false;
    this.totalProducts = total;
    this.currentPage = page;
    this.perPage = perPage;
  }

  searchProducts(params) {
    this.products = [];
    this.httpSearchProductsIsPending = true;
    this.getProducts(params).then(newData => this.onProductSearchSuccess(newData));
  }

  updateProducts() {
    if (!this.hasMoreProducts() || this.httpUpdateProductsIsPending) {
      return;
    }
    this.httpUpdateProductsIsPending = true;
    const paramsWithPagination = Object.assign({}, this.routerService.state.params, {page: this.currentPage += 1});
    this.getProducts(paramsWithPagination).then(newData => this.onProductUpdateSuccess(newData));
  }

  createBreadCrumbFromActiveFilters({gender = {}, category = {}}) {
    return [gender, category];
  }

  hasMoreProducts() {
    return this.infiniteTriggerService.canLoadMoreItems({
      totalItems: this.totalProducts,
      itemsPerPage: this.perPage,
      currentPage: this.currentPage,
    });
  }

  $onDestroy() {
    const prevScrollPosition = document.documentElement.scrollTop;
    this.productService.resetStore();
    this.routerService.state.transition.promise.then((state) => {
      const nextViewIsProductDetail = state.name === 'product';
      const productsToStore = nextViewIsProductDetail ? this.products : null;
      const scrollPositionToStore = nextViewIsProductDetail ? prevScrollPosition : 0;
      this.productService.storeProducts(productsToStore);
      this.productService.storeScrollProsition(scrollPositionToStore);
      this.productService.storePagination({
        totalProducts: this.totalProducts,
        currentPage: this.currentPage,
        perPage: this.perPage,
      });
    });
  }
}

export default ProductListController;



// WEBPACK FOOTER //
// ./src/app/product/product-list/product-list.controller.js